var _g, _circle, _circle2, _rect, _path, _g2, _g3, _rect2, _rect3, _rect4, _rect5, _rect6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExperience(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 434,
    height: 660,
    viewBox: "0 0 434 660",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1031_9826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.0918 627C103.023 627 151.108 614.816 193.592 593.204M168.592 24.4382C190.993 33.4438 212.11 44.969 231.592 58.6632",
    stroke: "#0C00FF",
    strokeWidth: 4,
    strokeLinecap: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 2.5,
    transform: "matrix(-1 0 0 1 237.592 566)",
    fill: "url(#paint0_linear_1031_9826)",
    stroke: "#0C00FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 2.5,
    transform: "matrix(-1 0 0 1 75.5918 3)",
    fill: "url(#paint1_linear_1031_9826)",
    stroke: "#0C00FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -2.44949,
    y: 1.41421,
    width: 279.462,
    height: 355.779,
    rx: 22,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 428.689 173.632)",
    fill: "#F5F6F8",
    fillOpacity: 0.6,
    stroke: "white",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.3638 409.027C57.0876 410.355 58.7341 413.375 60.3267 416.295C63.1891 421.544 66.4339 427.494 72.7182 429.177C79.0024 430.861 84.7872 427.331 89.8907 424.217C92.7296 422.484 95.6653 420.692 97.8228 420.404C100.166 420.09 103.598 421.069 106.918 422.014C107.361 422.14 107.81 422.268 108.262 422.394L89.8907 489.5C89.5001 490.958 88.4044 492.122 86.973 492.6C85.5419 493.079 83.9659 492.807 82.7777 491.877L60.2503 474.252L31.9286 478.252C31.321 478.338 30.7125 478.298 30.1367 478.143C29.2972 477.918 28.5275 477.451 27.9342 476.781C26.934 475.651 26.5669 474.095 26.9575 472.637L45.3284 405.531C45.7828 405.647 46.2351 405.761 46.6822 405.874C50.029 406.714 53.491 407.584 55.3638 409.027Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1031_9826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4118 348.118C34.0987 345.554 38.0662 343.381 41.9028 341.28C45.6415 339.232 49.5075 337.115 51.9846 333.878C54.565 330.506 55.6499 326.11 56.699 321.857C57.7205 317.718 58.7765 313.437 60.8687 312.223C62.968 311.004 67.2127 312.214 71.3186 313.383C75.5239 314.581 79.8701 315.819 84.0693 315.257C88.1028 314.718 91.8597 312.425 95.4932 310.208C99.2286 307.928 103.092 305.57 105.654 306.256C108.217 306.943 110.383 310.917 112.479 314.759C114.517 318.496 116.624 322.36 119.847 324.844C123.203 327.43 127.585 328.531 131.827 329.596C135.966 330.636 140.248 331.711 141.457 333.816C142.661 335.914 141.436 340.149 140.25 344.245C139.033 348.452 137.774 352.802 138.323 357.013C138.849 361.054 141.138 364.82 143.353 368.463C145.625 372.201 147.974 376.067 147.287 378.631C146.6 381.194 142.633 383.367 138.796 385.469C135.057 387.516 131.191 389.634 128.714 392.87C126.134 396.243 125.049 400.639 124 404.892C122.978 409.031 121.922 413.312 119.83 414.526C117.731 415.745 113.485 414.536 109.381 413.366C108.53 413.124 107.672 412.879 106.812 412.649C103.422 411.741 99.979 411.044 96.6295 411.492C92.5964 412.031 88.8395 414.324 85.206 416.541C81.4702 418.821 77.6072 421.179 75.0448 420.492C72.4824 419.806 70.3157 415.832 68.2204 411.99C66.1823 408.253 64.0752 404.389 60.8522 401.905C57.496 399.318 53.1107 398.218 48.872 397.152C44.7327 396.113 40.451 395.038 39.2422 392.933C38.0377 390.834 39.2633 386.599 40.4484 382.504C41.666 378.297 42.9251 373.947 42.3763 369.736C41.8496 365.695 39.5605 361.928 37.346 358.285C35.0741 354.547 32.7249 350.682 33.4118 348.118Z",
    fill: "url(#paint2_linear_1031_9826)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4152 309.536L72.4137 309.536L72.2767 309.497C70.3179 308.939 68.0455 308.292 65.9782 307.958C64.0917 307.654 61.2301 307.387 58.8603 308.763C56.4941 310.137 55.3079 312.752 54.6377 314.537C53.9012 316.498 53.3349 318.793 52.847 320.772L52.8155 320.899C51.7212 325.335 50.7896 328.858 48.8078 331.448C46.9392 333.889 43.896 335.628 39.9813 337.772L39.8614 337.837C38.0291 338.841 35.8941 340.01 34.132 341.285C32.4797 342.48 30.2765 344.364 29.5481 347.083C28.8197 349.801 29.7853 352.535 30.6186 354.396C31.5075 356.381 32.7722 358.462 33.8575 360.247L33.9278 360.363L33.9279 360.363C36.2465 364.177 38.0125 367.205 38.4098 370.253L72.4152 309.536ZM72.4152 309.536C76.8012 310.786 80.3147 311.724 83.5388 311.293C86.5841 310.885 89.6057 309.115 93.4094 306.793L93.5269 306.721C95.3104 305.633 97.389 304.364 99.3725 303.472C101.232 302.635 103.967 301.663 106.689 302.393C109.412 303.122 111.295 305.332 112.487 306.986C113.758 308.75 114.924 310.888 115.924 312.723L115.99 312.844C115.99 312.844 115.99 312.844 115.99 312.844C118.124 316.756 119.855 319.8 122.288 321.676L122.289 321.676M72.4152 309.536L122.289 321.676M122.289 321.676C124.865 323.662 128.377 324.606 132.801 325.717L132.801 325.717M122.289 321.676L132.801 325.717M132.801 325.717L132.923 325.747C134.903 326.244 137.201 326.821 139.164 327.568C140.95 328.248 143.561 329.448 144.925 331.824L144.926 331.825M132.801 325.717L144.926 331.825M144.926 331.825C146.288 334.197 146.008 337.055 145.696 338.936C145.353 341.002 144.696 343.273 144.129 345.23L144.093 345.357L144.093 345.357M144.926 331.825L144.093 345.357M144.093 345.357C142.823 349.745 141.868 353.262 142.289 356.496L144.093 345.357ZM140.718 388.977L140.718 388.977L140.837 388.912C142.669 387.908 144.805 386.739 146.567 385.464C148.219 384.269 150.422 382.385 151.151 379.666C151.879 376.948 150.914 374.214 150.08 372.353C149.191 370.368 147.927 368.288 146.842 366.503L146.771 366.386C146.771 366.386 146.771 366.386 146.771 366.386C144.452 362.571 142.686 359.544 142.289 356.496L140.718 388.977ZM140.718 388.977C136.803 391.121 133.76 392.86 131.891 395.301L140.718 388.977ZM127.883 405.85L127.883 405.85C128.978 401.414 129.909 397.891 131.891 395.301L127.883 405.85ZM127.883 405.85L127.852 405.977C127.364 407.956 126.798 410.251 126.061 412.212C125.391 413.997 124.205 416.612 121.838 417.986L119.847 414.555M127.883 405.85L119.847 414.555M119.847 414.555L121.838 417.986C119.469 419.361 116.608 419.095 114.721 418.791C112.646 418.457 110.366 417.806 108.402 417.246L108.285 417.213L108.284 417.213L108.264 417.207C107.415 416.965 106.595 416.732 105.777 416.513C102.459 415.624 99.6721 415.12 97.16 415.456C94.1152 415.864 91.0937 417.634 87.2898 419.956L87.1733 420.027C85.3893 421.116 83.3103 422.385 81.3263 423.277C79.4672 424.113 76.7316 425.085 74.0095 424.356C71.2874 423.627 69.4043 421.417 68.2124 419.763C66.9404 417.998 65.7745 415.86 64.7739 414.025L64.7087 413.905C62.5748 409.993 60.8436 406.948 58.4104 405.073L60.8522 401.905M119.847 414.555L60.8522 401.905M39.2422 392.933L35.7732 394.924C34.411 392.551 34.6912 389.694 35.0031 387.813C35.3458 385.746 36.0032 383.475 36.5696 381.518L36.6061 381.392C37.8762 377.004 38.8312 373.487 38.4098 370.253L39.2422 392.933ZM39.2422 392.933L35.7732 394.924C37.1376 397.301 39.7491 398.501 41.5354 399.181C43.4951 399.927 45.7896 400.503 47.7664 400.999L47.8967 401.032C47.897 401.032 47.8973 401.032 47.8976 401.032C52.3209 402.144 55.8336 403.087 58.4104 405.073L60.8522 401.905M39.2422 392.933L60.8522 401.905",
    stroke: "url(#paint3_linear_1031_9826)",
    strokeWidth: 8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1031_9826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.9737 357.008C71.3062 344.571 84.0966 337.154 96.4862 340.473C108.876 343.793 116.244 356.612 112.911 369.049C109.579 381.486 96.7885 388.903 84.3989 385.584C72.0094 382.264 64.6412 369.445 67.9737 357.008Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 90.4898,
    height: 8.72191,
    rx: 4,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 325.284 218.684)",
    fill: "#BED2F8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 99.2117,
    height: 8.72191,
    rx: 4,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 344.311 282.474)",
    fill: "#BED2F8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 99.2117,
    height: 8.72191,
    rx: 4,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 331.895 328.81)",
    fill: "#BED2F8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 99.2117,
    height: 8.72191,
    rx: 4,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 319.479 375.146)",
    fill: "#BED2F8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 99.2117,
    height: 8.72191,
    rx: 4,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 307.063 421.482)",
    fill: "#BED2F8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1031_9826",
    x: 29.0918,
    y: 11.4377,
    width: 225.5,
    height: 648.562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.466667 0 0 0 0 0.631373 0 0 0 0 0.94902 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1031_9826"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1031_9826",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1031_9826",
    x: 4.29102,
    y: 287.136,
    width: 172.116,
    height: 172.476,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.466667 0 0 0 0 0.631373 0 0 0 0 0.94902 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1031_9826"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1031_9826",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1031_9826",
    x: 46.1729,
    y: 328.681,
    width: 88.54,
    height: 88.695,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6 0 0 0 0 0.732258 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1031_9826"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1031_9826",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1031_9826",
    x1: 6,
    y1: -0.223428,
    x2: 6,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77A1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4362CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1031_9826",
    x1: 6,
    y1: -0.223428,
    x2: 6,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77A1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4362CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1031_9826",
    x1: 105.654,
    y1: 306.256,
    x2: 75.0448,
    y2: 420.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77A1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4362CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1031_9826",
    x1: 105.654,
    y1: 306.256,
    x2: 75.0448,
    y2: 420.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperience);
export default __webpack_public_path__ + "static/media/experience.95c8e6c278189050da65adf1fc0f2245.svg";
export { ForwardRef as ReactComponent };